// Libs
import * as React from 'react'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'

interface IClassesCardProps {
  item: any
  onCardSelect: (id: number) => void
  selected: boolean
}

const ClassesCard: React.SFC<IClassesCardProps> = (
  props: IClassesCardProps
) => {
  const { item, selected, onCardSelect } = props
  const { acf } = item

  const cardSelectedHandler = () => {
    onCardSelect(item.id)
  }

  return (
    <ClassesCardOuter>
      <Card className="card">
        <CardMedia
          style={{
            background: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)), url(${
              acf.card_image.url
            })`,
            height: '250px',
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
          }}
          image={acf.card_image.url}
          title={item.name}
          className="card-media"
        />
        <CardContent
          style={{paddingBottom: '0px'}}
        >
          <RadioGroupOuter>
            <RadioGroup>
              <FormControlLabel
                labelPlacement="start"
                value="female"
                control={
                  <Radio checked={selected} onClick={cardSelectedHandler} />
                }
                label="select"
              />
            </RadioGroup>
          </RadioGroupOuter>

          <Typography
            gutterBottom={true}
            variant="headline"
            component="h3"
            className="card-title"
          >
            {item.name}
          </Typography>
          {/* <Typography component="p" className="card-description">
            {acf.card_short_description}
          </Typography> */}
        </CardContent>
        <CardActions className="card-actions">
          <Button size="small" onClick={cardSelectedHandler}>
            {selected ? 'Remove' : 'Add'}
          </Button>
        </CardActions>
      </Card>
    </ClassesCardOuter>
  )
}

export default ClassesCard

const RadioGroupOuter = styled.div`
  > div:first-child {
    position: absolute;
    top: 0;
    right: 10px;

    span {
      color: #fff;
    }
  }
`
const ClassesCardOuter = styled.div`
  > div:first-child {
    position: relative;
  }

  .card {
    min-height: 230px;
  }

  .card-title {
    font-weight: 300;
    position: absolute;
    top: 63%;
    transform: translateY(-50%);
    color: #fff;
    text-transform: capitalize;
  }

  .card-description {
    font-size: 0.775rem;
  }

  .card-actions {
    display: flex;
    justify-content: flex-end;
    button {
      color: #0093b2;
    }
  }
`



// WEBPACK FOOTER //
// ./src/views/ClassesCard.tsx